import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { SingleSearchField, SingleSearchFieldProps } from './SingleSearchField';
import { MeiliIndex, SearchDatabaseResultItem, MeiliPlaylistData } from './types';
import { TypedMemo } from '../../../common/types';

export type PlaylistSearchFieldProps = Omit<SingleSearchFieldProps, 'queryType' | 'onSelected' | 'placeholder'> & {
  onPlaylistSelected: (playlist: MeiliPlaylistData) => void;
  placeholder?: string;
};

const PlaylistSearchFieldComponent: React.FC<PlaylistSearchFieldProps> = ({
  onPlaylistSelected,
  placeholder,
  ...props
}) => {
  const intl = useIntl();

  const defaultPlaceholder = intl.formatMessage({
    id: 'app.search.playlists.placeholder',
    defaultMessage: 'Search for playlists...',
  });

  const handleSelected = useCallback(
    (item: SearchDatabaseResultItem) => {
      if (item.type === MeiliIndex.playlists) {
        onPlaylistSelected(item.item);
      }
    },
    [onPlaylistSelected]
  );

  return (
    <SingleSearchField
      queryType={MeiliIndex.playlists}
      onSelected={handleSelected}
      placeholder={placeholder ?? defaultPlaceholder}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
};

export const PlaylistSearchField = TypedMemo(PlaylistSearchFieldComponent);
